export default __webpack_public_path__ + "39a9ddf39b6f0c9afad46674640b3609.svg";